module.exports = __webpack_public_path__ + "static/logo-230bb46086f9e3fa7118b222f423b414.png";